import Vuetify from 'vuetify';

export default {
  install(Vue) {
    Vue.use(Vuetify, {
      iconfont: 'md',
      theme: {
        primary: '#3F0C29',
        secondary: '#8F1C2C',
        background: '#BEBEBE',
        dark: '#333333',
        light: '#F2F2F2',
        buttonColorPrimary: '#8F1C2C',
        buttonColorSecondary: '#828282',
        error: '#DB2A2F',
        outline: '#EEEEEE',
      },
    });
  },
};
